<template>
  <div class="app">
    <div class="max-body body-top" @click="showFun()"><p class="name">
      {{ this.name }}
    </p><img src="../../assets/image/screenImg/duobianxing.png" alt="" class="duoboianxing"></div>
    <div v-if="listShow" v-clickoutside="handleClickOutside">
      <div class="max-body" v-for="(item) in createdObj" :key="item.path" @click="toRouter(item.path)"><p>
        {{ item.name }}</p></div>

    </div>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'

export default {
  directives: {Clickoutside},
  data() {
    return {
      createdObj: [
        {
          name: '龙门吊监测',//页面名称
          path: '/screenGantryCrane'//页面路由
        },
        {
          name: '升降机监测',
          path: '/monitorLift'
        },
        {
          name: '项目监控',
          path: '/supervisory'
        },

      ],
      listShow: false
    }
  },
  created() {
    console.log(this.name, this.topClass);
    // topClass(路由模块分类1：环境管理模块 3：劳务管理模块) createdObj是路由跳转信息数组对应的模块就赋值成为对应的数组，默认是安全管理模块
    if (this.topClass === 1) {
      this.createdObj = [{
        name: '扬尘监测',
        path: '/raise'
      }, {
        name: '能耗监测',
        path: '/energy'
      }]
    } else if (this.topClass === 3) {
      this.createdObj = [{
        name: '劳务管理',
        path: '/labourServices'
      },]

    }

    this.createdObj.forEach((element, index) => {
      // 父组件会传递过来一个name, 也就是页面名
      // 对路由跳转信息的数组进行循环，如果name和路由跳转信息的name相同那么就把这个对象从子列表删除放到默认盒子
      if (element.name == this.name) {
        this.createdObj.splice(index, 1)
      }
    });

  },
  methods: {
    handleClickOutside() {

    },
    showFun() {
      this.listShow = !this.listShow
    },
    toRouter(path) {
      this.$router.push({
        path: path
      })
    }

  },
  props: ["name", "topClass"]

}
</script>

<style scoped>
.max-body {
  width: 6.7708vw;
  height: 1.6667vw;
  opacity: 1;

  background: rgba(216, 216, 216, 0.01);

  box-sizing: border-box;
  border: 1px solid #608CCA;

  box-shadow: inset 0px 0px 17px 0px rgba(96, 140, 202, 0.6);
}

.max-body p {
  font-family: PingFang SC;
  font-size: .8333vw;
  font-weight: normal;
  letter-spacing: 0em;
  text-align: center;
  color: #FFFFFF;
  line-height: 1.6667vw;
}

.duoboianxing {
  width: .625vw;
  height: .3125vw;
  margin-top: 0.6772vw;
  margin-left: .2083vw;
  float: right;
}

.body-top {
  padding-left: .625vw;
  padding-right: .625vw;
}

.name {
  float: left;
}
</style>
